import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

import Formsy from 'formsy-react';
import { Row, Col, Button, Label, FormGroup, DefaultTooltip, Switch, FormSection, SheetFooter, SheetBody } from 'twyne-new.ui';

import ConfirmationPopover from '@Components/ConfirmationPopover';
import { buttonLabels } from '@Components/rules/options';
import Input from 'components/form/Input';
import Rules from 'components/rules/Rules';

const propTypes = {
  data: PropTypes.object,
  onSubmit: PropTypes.func,
  onRemoveProfile: PropTypes.func,
};

const RemoveButton = ({ onRemoveProfile, id }) => <>
  <ConfirmationPopover
    title={<span>Delete profile <i>{`[#${id}]`}</i></span>}
    id={id}
    target={
      <Button type='button' block color="danger" variant='ghost'>
        Remove
      </Button>
    }
  >
    <p><strong>Are you sure you want do this?</strong></p>
    <Button color="danger" onClick={onRemoveProfile} block>Yes, I am sure</Button>
  </ConfirmationPopover>
</>

export default function Form({ data, onSubmit, onRemoveProfile }) {
  const [rules, setRules] = useState({ condition: 'and', groups: [] })
  const [conflictEvent, setConflictEvent] = useState(null)
  const [name, setName] = useState()
  const [active, setActive] = useState(false)

  useEffect(() => {
    if (data.name) {
      setRules(data.rules)
      setName(data.name)
      setActive(data.active)
    }
  }, [data])

  const handleConflict = event => {
    setConflictEvent(event)
  }

  const handleChange = state => {
    setRules(state.rules)
  }

  const handleValidSubmit = () => {
    if (!name || conflictEvent !== "no-conflict") {
      return
    }

    onSubmit({ name, rules, id: data.id, active });
  }

  const disableForm = conflictEvent === 'conflict' || conflictEvent === 'checking'

  return (
    <Formsy onValidSubmit={handleValidSubmit}>
      <SheetBody>
        <Row>
          <Col size="10">
            <FormGroup>
              <Label>Name</Label>
              <Input name="name" value={name} required onChange={event => setName(event.target.value)} />
            </FormGroup>
          </Col>
          <Col size='2'>
            <DefaultTooltip side='left' content={!data.id || !data.hasPaths ? <>You cannot activate this profile yet. <br />Link a path to be able to activate it!</> : ''}>
              <FormGroup id='active-profile'>
                <Label>Active</Label>
                <Switch
                  onChange={event => setActive(event.target.checked)}
                  value={active}
                  disabled={!data.id || !data.hasPaths}
                />
              </FormGroup>
            </DefaultTooltip>
          </Col>
          <Col size="12">
            <FormSection>Rules</FormSection>
            <Rules rules={rules} handleChange={handleChange} origin='profile' onConflict={handleConflict} />
          </Col>
        </Row>
      </SheetBody>
      <SheetFooter>
        {data.id && <RemoveButton onRemoveProfile={onRemoveProfile} id={data.id} />}
        <DefaultTooltip content={disableForm ? 'You can\'t save the profile with rules conflict!' : ''}>
          <Button
            onClick={handleValidSubmit}
            disabled={disableForm}
            color='accent'
          >
            {buttonLabels[conflictEvent] || 'Save'}
          </Button>
        </DefaultTooltip>
      </SheetFooter>
    </Formsy>
  )
}

Form.propTypes = propTypes
Form.defaultProps = {}
